import { render } from "./EmbedLogin.vue?vue&type=template&id=cbdaf88a"
import script from "./EmbedLogin.vue?vue&type=script&lang=js"
export * from "./EmbedLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__